$(function() {
    var tipo_oferta = $('#tipo_oferta').val();
    var categoria = $('#categoria').val();
    var destino = $('#destino').val();
    var tipo_viaje = $('#tipo_viaje').val();

    function _post(uri, params, id) {
        $.post(uri, params, function(response) {
            $(id).html(response);
        });
    }

    function _getParams() {
        params = {
            tipo_oferta: tipo_oferta,
            categoria: categoria,
            destino: destino,
            tipo_viaje: tipo_viaje
        };
        _post("/views/layouts/components/_momentos.php", params, '#momentos_container');

    }

    $('body').on('change', '#tipo_oferta', function(e) {
        tipo_oferta = $(this).val();
        _getParams();
    });
    $('body').on('change', '#categoria', function(e) {
        categoria = $(this).val();
        _getParams();
    });
    $('body').on('change', '#destino', function(e) {
        destino = $(this).val();
        _getParams();
    });
    $('body').on('change', '#tipo_viaje', function(e) {
        tipo_viaje = $(this).val();
        _getParams();
    });
});


// WEBPACK FOOTER //
// ./assets/js/momentos.js